<app-user-header class="d-md-none"></app-user-header>


<div class="col-md-12 big-area p-0" *ngIf="opening">

    <div class="wrapperi">

        <div class="col-12">

            <div class="pointer" (click)="goBack()">
                <p class="semiboldlinkblue16 mb-0"><img src="../../assets/icons/chevron_left.svg"
                        class="chevron-margins" />Takaisin</p>
            </div>
        </div>

        <div class="col-12 m-0 p-0 mt-4">

            <div class="rekruu-job-header">
                <div class="d-flex justify-content-between">
                    <div class="d-flex logo-section justify-content-center align-items-center">

                        <div class="logo-container" *ngIf="company_data.logo;else no_logo_added">
                            <img src="{{company_data.logo}}" alt="" />
                        </div>
                        <ng-template #no_logo_added>
                            <img src="../../assets/images/formed_company.jpg" class="logo-wrap" alt="">
                        </ng-template>
                        <p class="ms-4 semiboldtextblue90020 mt-2">{{opening.company_name }}</p>
                    </div>
                    <div class="button-section d-inline-flex align-items-center">
                        <div class="">
                            <button class="btn btn-formed-main-blue ms-4"
                                routerLink="/{{businessID}}/openings/edit-opening/standard/{{openingID}}">
                                <img src="../../assets/icons/edit_icon_white.svg" class="me-2 margin-icon-neg" width="19" alt="" srcset="">
                                Muokkaa</button>

                        </div>
                        <div class="">
                            <button class="btn btn-formed-hollow ms-4" data-bs-toggle="modal"
                                data-bs-target="#delete-confirm-modal">
                                <img src="../../assets/icons/trash_icon.svg" width="15" class="margin-icon-neg me-2" alt="">
                                Poista</button>

                        </div>

                    </div>
                </div>
            </div>
            <div class="job-data-container mt-3">
                <div class="jobtitle">
                    <p class="semiboldtextblue90020">
                        <span *ngIf="opening.application_version == 2">{{opening.title}}</span>
                        <span *ngIf="!opening.application_version == 2">{{opening.mdType.name_fi}}</span>
                    </p>
                </div>
                <div class="col-12 row">
                    <div class="col-6">
                        <div class="job-item">
                            <div class="">
                                <div class="gray-box">
                                    <div class="width-20 text-center">
                                        <img width="20" src="../../assets/icons/location_dark_blue.svg">
                                    </div>
                                    <p class="normaltextblue90020OS mb-0 ms-1 sm-m"><span
                                            class="ms-2 normaltextblue90020OS">Sijainti:
                                        </span>{{opening.location.city}}</p>
                                </div>

                            </div>
                            <div class="">
                                <div class="gray-box" *ngIf="opening.subGroup">
                                    <div class="width-20 text-center">
                                        <img width="20" src="../../assets/icons/location_dark_blue.svg">
                                    </div>
                                    <p class="normaltextblue90020OS mb-0 ms-1 sm-m"><span
                                            class="ms-2 normaltextblue90020OS">Toimipiste:
                                        </span>{{opening.subGroup.businessName}}</p>
                                </div>

                            </div>

                            <div class="gray-box">
                                <div class="width-20 text-center">
                                    <img width="20" src="../../assets/icons/calendar_dark_blue.svg">
                                </div>
                                <p class="normaltextblue90020OS mb-0 ms-1 sm-m"><span
                                        class="ms-2 normaltextblue90020OS">Haku päättyy:
                                    </span>{{opening.application_ends | formateDate}}</p>
                            </div>


                        </div>
                    </div>
                    <div class="col-6">
                        <div class="job-item">
                            <div class="">
                                <div class="gray-box">
                                    <div class="width-20 text-center">
                                        <img width="20" src="../../assets/icons/clock_icon_blue.svg">
                                    </div>
                                    <p class="normaltextblue90020OS mb-0 ms-1 sm-m"><span
                                            class="ms-2 normaltextblue90020OS">Työaika: </span>{{opening.timing |
                                        worktimes}}</p>
                                </div>
                            </div>
                            <div class="">
                                <div class="gray-box" *ngIf="opening.subGroup">
                                    <div class="width-20 text-center">
                                        <img width="20" src="../../assets/icons/file_icon.svg">
                                    </div>
                                    <p class="normaltextblue90020OS mb-0 ms-1 sm-m"><span
                                            class="ms-2 normaltextblue90020OS">Työsuhde: </span>{{opening.work_type |
                                        workpossibility}}</p>
                                </div>
                            </div>
                            <div class="">
                                <div class="gray-box">
                                    <div class="width-20 text-center">
                                        <img width="20" src="../../assets/icons/remote_icon.svg">
                                    </div>
                                    <p class="normaltextblue90020OS mb-0 ms-1 sm-m"><span
                                            class="ms-2 normaltextblue90020OS">Etätyö: </span>
                                        <span *ngIf="opening.remote_possibility == 'partly'">Osittain</span>
                                        <span *ngIf="opening.remote_possibility == 'yes'">Kyllä</span>
                                        <span *ngIf="opening.remote_possibility == 'no'">Ei</span>
                                    </p>
                                </div>
                            </div>

                            <div class="gray-box" *ngIf="opening.wage_min || opening.wage_max">
                                <div class="width-20 text-center">
                                    <img width="20" src="../../assets/icons/wage_icon_blue.svg">
                                </div>
                                <p class="normaltextblue90020OS mb-0 ms-1 sm-m"><span
                                        class="ms-2 normaltextblue90020OS">Palkka: </span>
                                    <span *ngIf="opening.application_version == 2">
                                        <span *ngIf="opening.wage_min">{{opening.wage_min}}</span>
                                        <span *ngIf="opening.wage_max"> - {{opening.wage_max}}</span>
                                        <span *ngIf="opening.wage_type">{{opening.wage_type == 'hourly' ? '€/h' :
                                            '€/kk'}}</span>
                                    </span>
                                    <span *ngIf="opening.application_version != 2">

                                    </span>
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            <div class="desc-container">
                <div class="col-12 p-0 mt-1">
                    <div class=""
                        *ngIf="showFullDescription && opening.description_fi.length >= 200; else show_view_more">
                        <p class="normaltextblue90020OS allow-line-breaks">{{opening.description_fi}}</p>
                        <p (click)="setViewMore()" class="pointer semiboldlinkblue16">Näytä vähemmän</p>

                    </div>
                    <ng-template #show_view_more>
                        <div class="description-transition">
                            <div class="" *ngIf="opening.description_fi.length > 200; else not_full">
                                <p class="normaltextblue90020OS allow-line-breaks">{{opening.description_fi | truncate :
                                    450 : true}}</p>
                                <p (click)="setViewMore()" class="pointer semiboldlinkblue16">Näytä lisää</p>

                            </div>
                            <ng-template #not_full>
                                <p class="normaltextblue60018 allow-line-breaks">{{opening.description_fi}}</p>

                            </ng-template>

                        </div>
                    </ng-template>
                </div>
            </div>

        </div>
        <div class="button-container">
            <div class="d-flex">
                <button class="btn btn-formed-main-blue" (click)="openApplication()">Kiinnostuneet ({{opening.applicants.length}})</button>
                <button class="btn btn-formed-hollow ms-4" (click)="openCampaign()">Suositellut profiilit ({{matchingWishes.length}})</button>
            </div>
        </div>
        <div class="col-12  pb-4 pt-0">
            <div class="" *ngIf="opening && opening.applicants && opening.applicants.length > 0; else no_interest_content">
                <div class="row m-0 p-0">
                    <div class="col-md-4 ps-0 col-lg-4 col-xl-3 mt-4" *ngFor="let data of opening.applicants">
                        <div class="" *ngIf="true;else banner_template">
                            <div class="formed-border-radius relative formed-shadow pb-4">
                                <div class="wish-top-container bg-gray">
                                    <div class="p-3 d-flex justify-content-between">
                                        <div class="d-flex">
                                            <div class="new-badge" *ngIf="data.is_new">
                                                <p class="mb-0">Uusi</p>
                                            </div>
                                        </div>
                                        <div class="d-flex white-wish-heart-box" (click)="saveProfileToList(data)" *ngIf="!shared_view">
                                            <img class="" width="12" src="../../assets/icons/bookmark_icon.svg" />
                                        </div>
                                    </div>
                                </div>
                                <div class="more-z" (click)="fetchPublicProfile(data)">
                                    <div class="col-12 row m-0">
                                        <div class="boxer">
                                            <div class="transpa-bg cp">
                                                <div class="d-flex justify-content-center profile-picture-mt">
                                                    <div *ngIf="data['profilePicture'];else no_image">
                                                        <img width="120"
                                                            onerror="this.src='../../assets/icons/formed_no_profile.svg'"
                                                            class="rounded-circle" height="120"
                                                            src="{{data['profilePicture']}}" alt="">
                                                    </div>
                                                    <ng-template #no_image>
                                                        <div class="">
                                                            <img class="rounded-circle"
                                                                src="../../assets/icons/formed_no_profile.svg" width="120"
                                                                alt="">
                                                        </div>
                                                    </ng-template>
                                                </div>
                                                <div class="mt-2 text-center">
    
                                                    <div class="">
                                                        <p class="semiboldtextblue90020 mb-0">{{data.firstName}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class=" margin-10 d-flex flex-wrap justify-content-center d-lg-block">
                                                <div class="">
                                                    
                                                    <div class="gb-box d-flex align-items-center" *ngIf="data.areas && data.areas.length > 0">
                                                        <!-- Icon Section -->
                                                        <div class="icon-container d-flex align-items-center me-2">
                                                            <img src="../../assets/icons/location_dark_blue.svg" alt="Icon">
                                                        </div>
    
                                                        <!-- Skills and +X Section -->
                                                        <div
                                                            class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                            <!-- Skills List -->
                                                            <div class="skills-container">
                                                                <span class="normaltextblue80016 me-1 f-os"
                                                                    *ngFor="let area of data.areas; let i = index">
                                                                    <span *ngIf="i < 1">
                                                                        {{ area.name_fi }}<span *ngIf="i < 1"></span>
                                                                    </span>
                                                                </span>
                                                            </div>
    
                                                            <!-- +X Section -->
                                                            <div class="ms-2 badge-container">
                                                                <span class="text-end skill-num-tag normaltextblue60016"
                                                                    *ngIf="data.areas.length > 1">
                                                                    +{{ data.areas.length - 1 }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                    <div class="gb-box d-flex align-items-center">
                                                        <!-- Icon Section -->
                                                        <div class="icon-container d-flex align-items-center me-2">
                                                            <img src="../../assets/icons/language_icon.svg" alt="Icon">
                                                        </div>
    
                                                        <!-- Skills and +X Section -->
                                                        <div
                                                            class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                            <!-- Skills List -->
                                                            <div class="skills-container">
                                                                <span class="normaltextblue80016 me-1 f-os"
                                                                    *ngFor="let lang of data.languages; let i = index">
                                                                    <span *ngIf="i < 2">
                                                                        {{ lang.name_fi }}<span *ngIf="i < 1">,</span>
                                                                    </span>
                                                                </span>
                                                            </div>
    
                                                            <!-- +X Section -->
                                                            <div class="ms-2 badge-container">
                                                                <span class="text-end skill-num-tag normaltextblue60016"
                                                                    *ngIf="data.languages.length > 2">
                                                                    +{{ data.languages.length - 2 }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="gb-box d-flex align-items-center">
                                                        <!-- Icon Section -->
                                                        <div class="icon-container d-flex align-items-center me-2">
                                                            <img src="../../assets/icons/suitcase_icon.svg" alt="Icon">
                                                        </div>
    
                                                        <!-- Skills and +X Section -->
                                                        <div
                                                            class="d-flex justify-content-between flex-grow-1 align-items-center" *ngIf="data.job_titles && data.job_titles.length > 0;else no_job_titles">
                                                            <!-- Skills List -->
                                                             
                                                            <div class="skills-container">
                                                                <span class="normaltextblue80016 me-1 f-os"
                                                                    *ngFor="let title of data.job_titles; let i = index">
                                                                    <span *ngIf="i < 2">
                                                                        {{ title.name_fi }}<span *ngIf="i < 1">,</span>
                                                                    </span>
                                                                </span>
                                                            </div>
    
                                                            <!-- +X Section -->
                                                            <div class="ms-2 badge-container">
                                                                <span class="text-end skill-num-tag normaltextblue60016"
                                                                    *ngIf="data.job_titles.length > 2">
                                                                    +{{ data.job_titles.length - 2 }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <ng-template #no_job_titles>
                                                            <div class="skills-container">
                                                                <span class="normaltextblue80016 me-1 f-os">{{data.mdType.name_fi}}</span>
                                                            </div>
    
                                                        </ng-template>
                                                    </div>
                                                    <div class="gb-box d-flex align-items-center" *ngIf="data.skills && data.skills.length > 0">
                                                        <!-- Icon Section -->
                                                        <div class="icon-container d-flex align-items-center me-2">
                                                            <img src="../../assets/icons/suitcase_icon.svg" alt="Icon">
                                                        </div>
    
                                                        <!-- Skills and +X Section -->
                                                        <div
                                                            class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                            <!-- Skills List -->
                                                            <div class="skills-container">
                                                                <span class="normaltextblue80016 me-1 f-os"
                                                                    *ngFor="let skill of data.skills; let i = index">
                                                                    <span *ngIf="i < 3">
                                                                        {{ skill.name_fi }}<span *ngIf="i < 2">,</span>
                                                                    </span>
                                                                </span>
                                                            </div>
    
                                                            <!-- +X Section -->
                                                            <div class="ms-2 badge-container">
                                                                <span class="text-end skill-num-tag normaltextblue60016"
                                                                    *ngIf="data.skills.length > 3">
                                                                    +{{ data.skills.length - 3 }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template #banner_template>
                            <div (click)="routeAd(data)"
                                class="h-100 w-100 pointer formed-shadow relative formed-border-radius formed-shadow"
                                style="cursor: pointer;background: url({{data.image}}); background-size: cover">
                                <div class="pointer h-100 w-100"></div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
            <ng-template #no_interest_content>
                <div class=" mt-4 ps-2 pe-2">
                    <div class="bg-f-w formed-shadow col-12 row pb-4 mb-4 m-0" *ngIf="!isLoading">
                        <div class="col-2">
    
                        </div>
                        <div class="col-12 col-lg-8">
                            <div class="bg-f-w p-4">
                                <div class="justify-content-center d-flex">
                                    <img src="../../assets/images/no_search_found.png" height="270" alt="">
                                </div>
                                <div class="p-4">
                                    <p class="semiboldtextblue24 text-center mt-4">
                                        Ei tallennettuja profiileja.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-2">
    
                        </div>
                    </div>
                </div>
    
    
            </ng-template>
        </div>



    </div>
</div>

<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="details-btn" data-bs-target="#details-modal" style="display:none"></button>
<div class="modal fade" id="details-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Tiedot</h5>
                <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                <button type="button" class="close" id="close-offer" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="employerData">
                <h5 class="text-left">Tarjous</h5>
                <p class="text-left">Ikkunan alareunasta löydät yhteystiedot</p>
                <p><i>{{currentDescription}}</i></p>
                <h5 class="text-left">Yhteystiedot</h5>
                <p class="text-left mb-0"><b>Yrityksen nimi:</b> {{offerData.subGroupName}}</p>
                <p class="text-left mb-0"><b>Yhteyshenkilön nimi:</b> {{employerData.firstName}}
                    {{employerData.lastName}}</p>
                <p class="text-left mb-0"><b>Sähköposti:</b> {{employerData.email}}</p>
                <p class="text-left mb-0"><b>Puhelinnumero:</b> {{employerData.phone}}</p>


            </div>
        </div>
    </div>
</div>

<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="delete-confirm" data-bs-target="#delete-confirm-modal" style="display:none"></button>
<div class="modal fade" id="delete-confirm-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class=" w-100 modal-title" id="exampleModalLabel">Ilmoituksen poistaminen</h5>
                <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->

                <button id="close-confirm-modal" type="button" class="btn-close" data-bs-dismiss="modal">
                    <i class="fal fa-times"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="" *ngIf="!isLoading">
                    <p class="normaltextblue14">Kertoisitko meille syyn miksi haluat poistaa ilmoituksen?</p>
                    <div class="col-12 row m-0 pt-2">

                        <div class="form-floating mb-2 col-12  p-0">
                            <select type="text" id="deletion-reason" placeholder="Valitse poiston syy"
                                class="form-control">
                                <option value=""></option>
                                <option value="formed_found">Tekijä löytyi Formedin kautta</option>
                                <option value="other_place_found">Tekijä löytyi muualta </option>
                                <option value="cannot_find">Tekijää ei löydy</option>
                                <option value="error_in_opening">Ilmoituksessa on virhe</option>
                                <option value="other">Muu</option>
                            </select>
                            <label for="md-type">Valitse poiston syy*</label>
                        </div>

                    </div>
                </div>
                <div id="loader" class="loader-container mt-4" *ngIf="isLoading">
                    <div class="loader mx-auto"></div>
                    <p class="text-center pt-3">Tietoja poistetaan...</p>
                </div>


                <div class="text-center justify-content-center d-flex col-12 mt-4 ">
                    <button class="btn btn-formed-delete" (click)="deleteOpening()">Poista ilmoitus</button>
                </div>

            </div>
        </div>
    </div>
</div>

<button id="oc-profile" class="btn btn-primary" type="button" data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" style="display: none;"></button>
<div class="offcanvas offcanvas-end oc-33" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
    <div *ngIf="this.storable_profile && this.storable_profile" class="oc-content">
        <div class="oc-header">
            <div class="d-flex justify-content-between">
                <div class="d-flex">
                    <div class="d-flex align-items-center">
                        <button class="btn-close" type="button" data-bs-dismiss="offcanvas" aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="20" alt="">
                        </button>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="white-wish-heart-box pointer" (click)="saveProfileToList(this.storable_profile)">
                        <img class="" width="12" src="../../assets/icons/bookmark_icon.svg" />
                    </div>
                </div>
            </div>
        </div>
        <div class="transpa-bg cp">
            <div class="d-flex justify-content-center profile-picture-mt-lg">
                <div *ngIf="this.storable_profile && this.storable_profile['profilePicture'];else no_image">
                    <img width="166" onerror="this.src='../../assets/icons/formed_no_profile.svg'"
                        class="rounded-circle" height="166" src="{{this.storable_profile['profilePicture']}}" alt="">
                </div>
                <ng-template #no_image>
                    <div class="">
                        <img class="rounded-circle" src="../../assets/icons/formed_no_profile.svg" width="166" alt="">
                    </div>
                </ng-template>
            </div>
            <div class="mt-2 text-center">
                <p class="semiboldtextblue90024 mb-0">{{this.storable_profile.firstName}}</p>

            </div>
            <div class="d-flex w-100 justify-content-center">
                <div class="">
                    <div class="text-center justify-content-center d-flex">
                        <button class="text-center btn btn-formed-main-blue mt-2 mb-3" (click)="sendMessage()"><img
                                class="me-2 neg-margin-2" width="18"
                                src="../../assets/icons/paperplane_white.svg" />Lähetä viesti</button>
                    </div>

                </div>
            </div>
            <div class="mb-3" *ngIf="contacted_by.length > 0">
                <div class="justify-content-center flex-column flex-lg-row d-lg-flex justify-content-lg-center"
                    *ngFor="let data of contacted_by">
                    <div class=" ps-4 ps-md-0 me-3">
                        <div [ngClass]="this.storable_profile.can_open ? '' : ''"
                            class=" ms-3 ms-lg-0 justify-content-center align-items-center d-flex">
                            <p class="cbtext mb-0 "><img class="me-2 mb-1" width="30" height="30"
                                    src="../../assets/icons/contactedby.svg" />{{data.employer.firstName}} kontaktoinut
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="bubble-box mt-20">
                <p class="gradient-text mb-0">Profiili</p>
                <div class="d-flex mt-2">
                    <div class="icon-width text-center">
                        <img src="../../assets/icons/email_icon.svg">

                    </div>
                    <div class="">
                        <p class="normaltextblue80016 mb-0 f-os ms-text-start sm-m"><strong>Sähköposti: </strong>
                            {{this.storable_profile.email}}</p>
                    </div>
                </div>
                <div class="d-flex mt-2">
                    <div class="icon-width text-center">
                        <img src="../../assets/icons/language_icon.svg">

                    </div>
                    <div class="">
                        <p class="normaltextblue80016 mb-0 f-os ms-text-start sm-m"><strong>Kielitaito: </strong>
                            {{this.storable_profile.display_lang}}</p>
                    </div>
                </div>
                <div class="d-flex mt-2">
                    <div class="icon-width text-center">
                        <img src="../../assets/icons/school_icon.svg">

                    </div>
                    <div class="">
                        <p class="normaltextblue80016 mb-0 f-os ms-text-start sm-m"><strong>Koulutus: </strong>
                            {{this.storable_profile.display_school}}</p>
                    </div>
                </div>
                <div class="gbb-box d-flex align-items-center" *ngIf="this.storable_profile.areas && this.storable_profile.areas.length > 0">
                    <!-- Icon Section -->
                    <div class="icon-container d-flex align-items-center me-2">
                        <img src="../../assets/icons/location_dark_blue.svg" alt="Icon">
                    </div>

                

                    <!-- Skills and +X Section -->
                    <div class="d-flex justify-content-between flex-grow-1 align-items-center">
                        <!-- Skills List -->
                        <div class="skills-container d-flex">
                            <p class="normaltextblue80016 me-1 ms-1 f-os mb-0"><strong>Sijainnit:</strong></p>
                            <span class="normaltextblue80016 me-1 f-os"
                                *ngFor="let area of this.storable_profile.areas; let i = index">
                                <span>
                                    {{ area.name_fi }}<span>,</span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="mt-10">
                    <p class="gradient-text mb-0">Tietoja minusta</p>
                    <div class="mt-2">
                        <p class="normaltextblue80016 mb-0 f-os">{{this.storable_profile.description}}</p>
                    </div>
                </div>
                <div class="mt-10" *ngIf="this.storable_profile.skills && this.storable_profile.skills.length > 0">
                    <p class="mb-0 normaltextgray50016">Taidot & tutkinnot</p>
                    <div class="d-flex flex-wrap">
                        <div class="blue-gradient-border me-2 mt-2" *ngFor="let skill of this.storable_profile.skills">
                            <p class="mb-0">{{skill.name_fi}}</p>
                        </div>

                    </div>
                </div>
                <div class="mt-10" *ngIf="this.storable_profile.cv && this.storable_profile.cv.length > 0">
                    <p class="mb-0 normaltextgray50016">Työkokemus</p>
                    <div class="bg-blue100 mt-2" *ngFor="let cv of this.storable_profile.cv">
                        <p class="mb-0 semiboldtextblue90016">{{cv.position}}</p>
                        <p class="mb-0 normaltextgray40014">{{cv.company}}</p>
                        <p class="d-flex normaltextblue60016 mb-0">
                            <span>{{cv.startDate.month.id}}.{{cv.startDate.year}}</span>-<span>{{cv.endDate != "" ?
                                cv.endDate.month.id + '.' + cv.endDate.year : ""}}</span>
                        </p>
                        <p class="mt-1 normaltextblue80016 mb-0">{{cv.description}}</p>
                    </div>


                </div>
                <div class="mt-10" *ngIf="this.storable_profile.job_titles && this.storable_profile.job_titles.length > 0">
                    <p class="mb-0 normaltextgray50016">Kiinnostunut näistä työnimikkeistä</p>
                    <div class="d-flex flex-wrap">
                        <div class="gray-border me-2 mt-2" *ngFor="let title of this.storable_profile.job_titles">
                            <p class="mb-0">{{title.name_fi}}</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</div>


<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="create-campaign-btn" data-bs-target="#create-campaign" style="display:none"></button>
<div class="modal fade" id="create-campaign" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class=" w-100 modal-title" id="exampleModalLabel">Boosted</h5>
                <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                <button id="close-confirm-modal-boost" type="button" class="btn-close" data-bs-dismiss="modal">
                    <i class="fal fa-times"></i>
                </button>
            </div>
            <div class="modal-body">
                <ng-container
                    *ngIf="day_price && company && company.einvoiceaddress && company.operator && company.vatID;else no_business_data">
                    <p class="normaltextblue14">Haluatko ilmoituksellesi enemmän näkyvyyttä?</p>
                    <p class="normaltextblue14 ">Boostedin avulla voit nostaa ilmoituksesi sovelluksen etusivulle ja
                        hakutulosten kärkeen!</p>
                    <p class="semiboldtextblue80016 mb-3">Valitse Boostauksen kesto syöttämällä päivien lukumäärä:</p>

                    <div class=" mb-2 col-12 col-md-12 p-0">
                        <input type="number" min="0" placeholder="" (keyup)="updatePrice()" id="campaign"
                            class="form-control">


                    </div>
                    <p class="normaltextblue14">Boosted {{day_price}}€/pv (alv.0%)</p>

                    <p class="semiboldtextblue80016 mb-3">Lisää haluamasi viite (esim. kustannuspaikka)</p>

                    <div class=" mb-2 col-12 col-md-12 p-0">
                        <input type="text" placeholder="" (keyup)="updatePrice()" id="cost_center" class="form-control">

                    </div>

                    <div id="loader" class="loader-container mt-4" *ngIf="isLoading">
                        <div class="loader mx-auto"></div>
                        <p class="text-center pt-3">Tietoja tallennetaan...</p>
                    </div>

                    <div class="d-flex mt-2">
                        <p class="semiboldtextblue80016 mb-0">Yhteensä:</p>
                        <p class="normaltextblue80016 mb-0 ms-2">{{price}}€ (alv.0%)</p>
                    </div>

                    <div class="text-center col-12 mt-4 ">
                        <button class="btn btn-formed-main-gold mt-4" (click)="increaseCampaign()">Aloita</button>
                    </div>

                </ng-container>
                <ng-template #no_business_data>
                    <div class="alert alert-warning">
                        <p class="mb-0 text-center">Sinun tulee lisätä organisaatiosi verkkolaskutustiedot ennen
                            Boostauksen aloittamista. </p>
                        <div class="text-center mt-4">
                            <button class="btn btn-formed-main-blue" data-bs-dismiss="modal"
                                routerLink="/{{businessID}}/edit-business">Lisää ne tästä</button>
                        </div>
                    </div>

                </ng-template>




            </div>
        </div>
    </div>
</div>

<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="list-created" data-bs-target="#list-created-modal" style="display:none"></button>
<div class="modal fade" id="list-created-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="">
                <div class="ps-4 pe-4 pt-4 d-flex justify-content-between">
                    <div class="">
                        <div class="d-inline-flex">
                            <div class="icon-cont">
                                <img src="../../assets/icons/check_icon_filled.svg" width="25" alt="">
                            </div>
                            <div class="ms-3 ">
                                <h5 class="semiboldtextblue90024" id="exampleModalLabel">Lista luotu</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flex-end">
                        <button id="close-list-created" type="button" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="15" alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <p class="normaltextblue90016 f-os">Lisäsimme profiilin automaattisesti uuteen listaan. Voit tutustua listoihin alla olevasta painikkeesta.</p>

                <div class="col 12 row m-0 mt-20">
                    <div class="">
                        <button class="btn btn-formed-main-blue w-100" (click)="routeToLists()"><img src="../../assets/icons/bookmark_icon_white.svg" class="me-2" width="12" /> listat</button>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="exampleModalToggle2" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2"
    tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="">
                <div class="p-4 d-flex justify-content-between">
                    <div class="">
                        <div class="d-inline-flex">
                            <div class="icon-cont">
                                <img src="../../assets/icons/bookmark_filled.svg" width="14" alt="">
                            </div>
                            <div class="ms-3 ">
                                <h5 class="semiboldtextblue90024" id="exampleModalLabel">Luo uusi lista</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flex-end">
                        <button id="close-confirm-modal" type="button" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="15" alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="">
                    <input type="text" placeholder="Otsikko*" id="list-title" class="form-control">
                </div>
                <div class="mt-2">
                    <input type="text" placeholder="Kuvaus*" id="list-description" class="form-control">
                </div>

                <div class="accordion rekruu-accordion p-10 accordion-flush mt-2" id="accordionFlushExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-headingOne">
                            <button class="accordion-button rekruu-accordion-button collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false"
                                aria-controls="flush-collapseOne">
                                Valitse kenellä on oikeus katsoa listaa
                            </button>
                        </h2>
                        <div id="flush-collapseOne" class="accordion-collapse collapse"
                            aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                <div class="pointer" *ngFor="let data of rights"
                                    [ngClass]="!data.selected ? '' : 'bg-selected-acc-item'"
                                    (click)="selectRight(data)">
                                    <div class="d-flex justify-content-between p-10 align-items-center">
                                        <div class="d-inline-flex">
                                            <div class="icon-container-acc icon-width me-2">
                                                <img src="{{data.icon_src}}" class="" alt="">
                                            </div>
                                            <div class="name">
                                                <p class="normaltextblue90016 mb-0">
                                                    <strong>{{data.highlighted}}</strong>{{data.normal}}</p>
                                            </div>
                                        </div>
                                        <div class="check-icon-container" *ngIf="data.selected">
                                            <img src="../../assets/icons/check_icon.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 p-10 row m-0 mb-20 pt-0">
                <div class="col-6 d-flex ps-1">
                    <button class="btn btn-formed-hollow w-100" id="close_create_new_list"
                        data-bs-dismiss="modal">Peruuta</button>
                </div>
                <div class="col-6 pe-1">
                    <button class="btn btn-formed-main-blue w-100" (click)="createANewList()">Tallenna</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="save-list" data-bs-target="#save-list-modal" style="display:none"></button>
<div class="modal fade" id="save-list-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="">
                <div class="ps-4 pe-4 pt-4 d-flex justify-content-between">
                    <div class="">
                        <div class="d-inline-flex">
                            <div class="icon-cont">
                                <img src="../../assets/icons/bookmark_filled.svg" width="14" alt="">
                            </div>
                            <div class="ms-3 ">
                                <h5 class="semiboldtextblue90024" id="exampleModalLabel">Tallenna profiili listaan</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flex-end">
                        <button id="close-confirm-modal" type="button" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="15" alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="" *ngIf="employer_lists.length > 0">
                    <div class="mb-20"*ngIf="already_in_list.length > 0">
                        <p class="normaltextblue90016 f-os">Profiili on jo alla olevissa listoissa</p>
                        <div *ngFor="let data of already_in_list" class="">
                            <div class="already-in-list-container mt-2 p-10">
                                <div class="justify-content-between align-items-center d-flex">
                                    <div class="list-name-cont">
                                        <p class="semiboldtextblue90016 mb-0 f-os">{{data.name}}</p>
                                    </div>
                                    <div class="remove-cont pointer">
                                        <p (click)="removeItemFromList(data)" class="semiboldtextblue60016 mb-0 f-os">Poista</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <p class="normaltextblue90016 f-os">
                        <span *ngIf="already_in_list.length > 0">Valitse toinen lista</span>
                        <span *ngIf="already_in_list.length == 0">Voit valita useita listoja</span>
                        </p>
                    <div class="accordion rekruu-accordion accordion-flush mb-20" id="accordionFlushExample">
                        <div class="accordion-item" style="border-radius: 10px;">
                            <h2 class="accordion-header" id="flush-headingOne">
                                <button class="accordion-button p-10 rekruu-accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false"
                                    aria-controls="flush-collapseOne">
                                    Valitse lista
                                </button>
                            </h2>
                            <div id="flush-collapseOne" class="accordion-collapse collapse"
                                aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                <div *ngFor="let list of employer_lists" (click)="selectList(list)"
                                    [ngClass]="list.selected ? 'rekruu-acc-selected-item' : 'p-10'" class="">
                                    <div class="pointer">
                                        <div class="d-flex justify-content-between">
                                            <div class="acc-name-container">
                                                <p [ngClass]="list.selected ? 'semiboldtextblue90016' : 'normaltextblue90016'"
                                                    class="f-os mb-0">{{list.name}}</p>
                                            </div>
                                            <div class="selected-item-container" *ngIf="list.selected">
                                                <img src="../../assets/icons/check_icon.svg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="create-new-container ">
                    <button class="btn btn-formed-light-blue w-100" data-bs-target="#exampleModalToggle2"
                        data-bs-toggle="modal" data-bs-dismiss="modal"><img class="me-3 margin-light-blue-icon"
                            src="../../assets/icons/plus_icon.svg" />Luo uusi
                        lista</button>
                </div>
                <div class="col 12 row m-0 mt-20" *ngIf="employer_lists.length > 0">
                    <div class="col-6 d-flex ps-0">
                        <button class="btn btn-formed-hollow w-100" id="close-save-list" data-bs-dismiss="modal">Peruuta</button>
                    </div>
                    <div class="col-6 pe-0">
                        <button class="btn btn-formed-main-blue w-100" (click)="saveToList()">Tallenna</button>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>
